import { type FC } from 'react';

import { IconArrowLeft } from '@tabler/icons-react';
import { ButtonFieldIcon } from '@wk/components-react16';

import type { OnboardingFlowHeaderProps } from '@/features/onboarding/types/onboarding.types';

const OnboardingFlowHeader: FC<OnboardingFlowHeaderProps> = ({
  onBack,
  title,
}) => (
  <h1 className="flex items-center gap-2 text-2xl font-bold">
    <ButtonFieldIcon>
      <button onClick={onBack}>
        <IconArrowLeft size={28} />
      </button>
    </ButtonFieldIcon>
    {title}
  </h1>
);

export default OnboardingFlowHeader;
